import { render, staticRenderFns } from "./EditUnit.vue?vue&type=template&id=354e94fb&scoped=true&"
import script from "./EditUnit.vue?vue&type=script&lang=js&"
export * from "./EditUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e94fb",
  null
  
)

export default component.exports